import text from 'powtoon-html-player/src/dynamic/typeMapping/text'
import link from 'powtoon-html-player/src/dynamic/typeMapping/link'
import {filter, map, reduce} from 'lodash'
const typeMapping = {
  text,
  link
}

export default function transformDynamicTrack (track, transformConfig) {
  const {dynamicAttributesForTrack, dynamicData: {dynamic_items: dynamicItems}} = transformConfig
  if (!dynamicAttributesForTrack) {
    return track
  }
  else
  {
    const newTrack = reduce (Object.entries(typeMapping), (newTrack, [type, typeTransformFunction]) => {
      const typedSlugs = filter(dynamicAttributesForTrack, spriteDynamicAttribute => {
        return spriteDynamicAttribute.type === type
      })
      const trackSlugsData = map(typedSlugs, (typedSlug) => {
        const slugNewValue = dynamicItems[typedSlug.slug]
        return  {slug: typedSlug.slug, slugNewValue}
      })

      if (trackSlugsData && trackSlugsData.length>0){
        newTrack =  typeTransformFunction(newTrack, trackSlugsData)
      }
      return newTrack
    }, track)
    return newTrack
  }
  

}